module.exports = __webpack_public_path__ + "img/sugar.9a05637.png";